import {
  FC,
  useCallback,
  useState,
} from "react";

import { useIsMobile } from "@repo/edtech-shared";

import { StarsRating } from "../../../stars-rating";

import st from "./SurveyRating.module.scss";

interface Props {
  rating: number | null,
  maxRating: number,
  onSubmit: (value: number) => void,
}

export const SurveyRating: FC<Props> = ({
  rating,
  maxRating,
  onSubmit,
}) => {
  const isMobile = useIsMobile(768);
  const [ hoveredRating, setHoveredRating ] = useState<number | null>(null);

  const handleHoverChange = useCallback((num: number | null) => {
    setHoveredRating(num);
  }, []);

  const handleStarClick = useCallback((value: number) => {
    onSubmit(value);
  }, [ onSubmit ]);

  return (
    <div className={st.rating_row}>
      <StarsRating
        activeStar={hoveredRating ?? rating}
        iconClassName={st.star}
        isMobile={isMobile}
        maxRating={maxRating}
        wrapClassName={st.stars}
        onHoverChange={handleHoverChange}
        onStarClick={handleStarClick}
      />
      {
        rating !== null && (
          <span className={st.rating_label}>{rating} из {maxRating}</span>
        )
      }
    </div>
  );
};
